import { API_DOMAIN, STATUS_CODE } from "@constants/api";

/**
 * Get seats for a casino game
 * @param {Object} params - { pgc, ipg, ukey }
 * pgc: seats per page (fixed 20)
 * ipg: game index + page number (e.g., "A1", "B2", "C3")
 * ukey: user key
 */
export const getSeats = async ({ pgc = 20, ipg, ukey }) => {
    const url = `${API_DOMAIN}/getSeats.ashx?pgc=${pgc}&ipg=${ipg}&ukey=${ukey}`;
    const res = await fetch(url);
    return res.json();
};

/**
 * Get seat history
 * @param {Object} params - { cacc, ukey }
 * cacc: casino account (e.g., "TT06C022")
 * ukey: user key
 */
export const getSeatHis = async ({ cacc, ukey }) => {
    const url = `${API_DOMAIN}/getSeatHis.ashx?cacc=${cacc}&ukey=${ukey}`;
    const res = await fetch(url);
    return res.json();
};

/**
 * Get casino play URL
 * @param {Object} params - { cacc, ukey }
 * cacc: casino account (e.g., "TT06C022")
 * ukey: user key
 */
export const getCasinoPlay = async ({ cacc, ukey }) => {
    const url = `${API_DOMAIN}/getCasinoPlay.ashx?cacc=${cacc}&ukey=${ukey}`;
    const res = await fetch(url);
    return res.json();
};

/**
 * Exit current seat
 * @param {Object} params - { ukey }
 * ukey: user key
 */
export const exitSeat = async ({ ukey }) => {
    const url = `${API_DOMAIN}/exitSeat.ashx?ukey=${ukey}`;
    const res = await fetch(url);
    return res.json();
};

/**
 * Exit current seat using sendBeacon (for beforeunload)
 * sendBeacon is more reliable when page is closing
 * @param {Object} params - { ukey }
 * ukey: user key
 */
export const exitSeatBeacon = ({ ukey }) => {
    const url = `${API_DOMAIN}/exitSeat.ashx?ukey=${ukey}`;
    // sendBeacon returns true if successfully queued
    return navigator.sendBeacon(url);
};

export { STATUS_CODE };
